export default __webpack_public_path__ + "static/media/lime-399 1.e709988e.png";